// extracted by mini-css-extract-plugin
export default {"entry":"entry--m55Tv","titleset":"titleset--TmhD1","title":"title--bhm5T","logo":"logo--0UTGq","description":"description--3DqSb","links":"links--fAHEE"};